import React from "react";
import styles from "./index.module.scss";
import { BiUndo } from "react-icons/bi";
import { Button } from "antd";
import { useHistory } from "react-router-dom";
import SearchBar from "../SearchBar";
import TabExams from "../TabExams";
import ExamInfo from "../ExamInfo";
import { useToggle } from "react-use";
import classNames from "classnames";

interface LayoutProps {
    title: string;
    children?: React.ReactNode;
    extra?: React.ReactNode;
    table?: React.ReactNode;
    aside?: React.ReactNode;
    showRight?: boolean;
    searchBar?: React.ReactNode;
    showTab?: boolean;
    showTitle?: boolean;
    showInfo?: boolean;
    onSearch?: (text: string) => void;
    refresh?: () => void;
}

export default function Layout({
    title,
    children,
    extra,
    table,
    aside,
    refresh,
    showRight = true,
    showTab = true,
    showTitle = true,
    showInfo = true,
    searchBar,
    onSearch
}: LayoutProps) {
    const history = useHistory();

    const [full, toggleFull] = useToggle(true);

    return (
        <div className={styles.root}>
            {showTitle && (
                <div className={styles.header}>
                    <h1 className={styles.title}>
                        {title}
                        <Button
                            className={styles.back}
                            onClick={() => history.goBack()}>
                            <BiUndo size={16} /> 返回
                        </Button>
                    </h1>

                    {extra}
                </div>
            )}

            <div className={styles.body}>
                {searchBar}
                {onSearch && (
                    <SearchBar refresh={refresh} onSearch={onSearch} />
                )}
                {showTab && <TabExams />}

                {children}

                <div className={styles.main}>
                    <div className={styles.table}>{table}</div>
                    {showRight && (
                        <div
                            className={classNames(
                                styles.aside,
                                full ? styles.full : styles.notFull
                            )}>
                            <div className={styles.min} onClick={toggleFull}>
                                {full ? "收起" : "展开"}
                            </div>
                            {full && aside}
                            {showInfo && full && <ExamInfo />}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}
